/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * FolderOpenIcon
 */
export default class FolderOpenIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M6.172 3a3 3 0 012.12.879l.83.828A1 1 0 009.827 5H18a3 3 0 013 3l.001.1a3.001 3.001 0 012.151 3.575l-1.615 7A3 3 0 0118.613 21H4.062a3 3 0 01-2.971-2.583A1 1 0 011 18V6a3 3 0 013-3zm14.057 7H6.216a1 1 0 00-.956.706l-2.154 7A1 1 0 004.062 19h14.551a1 1 0 00.975-.775l1.615-7A1 1 0 0020.23 10zM6.172 5H4a1 1 0 00-1 1v5.248l.348-1.13A3 3 0 016.216 8H19a1 1 0 00-1-1H9.828a3 3 0 01-2.12-.879l-.83-.828A1 1 0 006.173 5z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

